import { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { Loader2, ExternalLink, Pencil } from "lucide-react";
import { QuoteEstimate } from "../QuoteEstimate";

// Booking-mode view of the linked quote: editable estimate + configurator link,
// so the quote stays fully editable at ANY stage of the job.
export function LinkedQuote({ quoteId }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!quoteId) return;
    api.get(`/admin/quote/${encodeURIComponent(quoteId)}`).then(r => setData(r.data)).catch(() => setErr(true));
  }, [quoteId]);

  if (!quoteId) return (
    <div className="border border-dashed border-[#E5E7EB] bg-[#F8F6F2] p-4 text-xs text-[#6B7280]" data-testid="linked-quote-none">
      No linked quote — this job was booked directly. Adjust pricing via the invoice on the Money tab.
    </div>
  );
  if (err) return <div className="border border-[#F5C7C0] bg-[#FEF6F5] p-4 text-xs text-[#8A2A1E]" data-testid="linked-quote-error">The original quote could not be loaded.</div>;
  if (!data) return <div className="py-4 text-sm text-[#6B7280]"><Loader2 size={14} className="animate-spin inline mr-2" /> Loading quote…</div>;

  const handleSaved = (patch) => {
    setData(d => {
      if (!d) return d;
      const { estimate, revision, ...rest } = patch;
      const next = { ...d, ...rest };
      if (estimate) {
        next.estimate = estimate;
        next.total_inc_vat = estimate.total_inc_vat;
        next.estimate_revisions = [...(d.estimate_revisions || []), revision];
      }
      return next;
    });
  };

  return (
    <div data-testid="linked-quote">
      <div className="border border-[#F0D5B4] bg-[#FBF3EC] p-3 mb-4 flex items-center justify-between gap-3 flex-wrap">
        <p className="text-xs text-[#6B7280]">
          <Pencil size={12} className="inline mr-1.5 text-[#C79A3B]" />
          The quote stays editable after booking — every save is a numbered revision the client can view in their portal.
          The job invoice on the Money tab is separate.
        </p>
        {data.route === "pd" && (
          <a href={`/quote?edit=${data.quote_id}`} target="_blank" rel="noreferrer" data-testid="linked-quote-edit-configurator"
            className="text-xs font-bold text-[#C79A3B] hover:text-[#A87E28] inline-flex items-center gap-1 shrink-0">
            <ExternalLink size={12} /> Edit in configurator as customer
          </a>
        )}
      </div>
      <QuoteEstimate quoteId={quoteId} data={data} onSaved={handleSaved} />
    </div>
  );
}
